module.exports = __webpack_public_path__ + "img/banner-14-1@2x.6865fe96.jpg";